import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const FirstLineContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.dark,
  color: theme.palette.primary.contrastText,
  borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`,
  display: "flex",
  flexDirection: "row", // Align children horizontally
  justifyContent: "space-between", // This will space out children horizontally
  alignItems: "center", // This will center children vertically
  padding: theme.spacing(0.2),
  marginBottom: theme.spacing(0.2),
}));

export default FirstLineContainer;
